






































































































import Vue from "vue";
import Component from "vue-class-component";
import func from "@/ts/FormFunctions";
import { IVueStateCollection } from "@/ts/FormBuilder";
import ErrorMessages from "@/ts/constants/ReportingErrorMessages";
import { ILiquidHazardousWasteVueModel } from "@/ts/models/ILiquidHazardousWasteVueModel";

@Component({
    props: {
        form: {
            type: Object as () => ILiquidHazardousWasteVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    }
})
export default class LiquidHazardousWasteMaterials extends Vue {
    name: string = "LiquidHazardousWasteMaterials";
    title: string = "";
    isDisabled: boolean = false;

    errorMsgs = ErrorMessages;

    mounted(): void {
        this.title = this.$props.vueStates.views[1].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", 1);

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[1].error = this.hasErrors;
        }, { immediate: true });

        this.$props.vueStates.views[1].visited = true;

        this.$watch("volumeFee", (n, o) => {
            this.$props.form.fees[0].amount = n;
        }, { immediate: true });
    }

    checkChanged(): void {
        if (this.$props.form.isNotLiquidWaste) {
            this.$props.form.volume = 0;
            this.$props.form.volumeReclaimed = 0;
            this.isDisabled = true;
        } else {
            this.isDisabled = false;
        }
    }

    get year(): number {
        if (this.$props.form.reportingPeriod == null) {
            return 0;
        }
        return this.$props.form.reportingPeriod.getFullYear();
    }

    get isVolumeError(): boolean {
        if (this.isDisabled) return false;
        return func.isNullOrEmpty(this.$props.form.volume) || this.$props.form.volume < 0;
    }

    get isVolumeReclaimedError(): boolean {
        return (this.$props.form.volumeReclaimed - 0) > (this.$props.form.volume - 0);
    }

    get volumeSubjectToFee(): number {
        let value = (this.$props.form.volume * 1) - (this.$props.form.volumeReclaimed * 1);
        if (value < 420 || value === NaN) {
            return 0.00;
        }
        return value;
    }

    get volumeFee(): number {
        return this.volumeSubjectToFee * 0.02;
    }
    
    get hasErrors(): boolean {
        return this.isVolumeError || this.isVolumeReclaimedError;
    }
}
